import React from 'react'
import PropTypes from 'prop-types';

import moment from 'moment';
import { Button } from 'react-bootstrap'
import { TextInput, LabelGroup, InsetSection, JsonEditorDialog, Text, Flex } from '~/views';

import style from './style.css'

export default class MessageRouteEditor extends React.Component {

  static propTypes = {
    messageRoute : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { showDialog : false }
  }

  changePath( path, value, err ) {
    const { messageRoute } = this.props
    if ( err ) {
      console.log( `error setting ${path} to ${value}` );
      return;
    }
    this.props.onChange( { target : this.props.messageRoute, path, value, item : messageRoute } );
  }

  render() {
    const { messageRoute } = this.props
    if ( messageRoute == null ) {
      return <div />
    }

    const { routes } = messageRoute

    return (
      <Flex variant="vSpace" direction="column" align="stretch">
        <LabelGroup>
          <label>ID</label>
          <Text type="dim" text={messageRoute.id} />
        </LabelGroup>
        <LabelGroup>
          <label>Name</label>
          <TextInput
            hint="Name..."
            value={messageRoute.name} 
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
        </LabelGroup>
        <LabelGroup>
          <label>Description</label>
          <TextInput
            hint="Description..."
            value={messageRoute.description}
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'description', v, err ) }} />
        </LabelGroup>
        <LabelGroup vertical>
          <LabelGroup>
            <label>Routes</label>
            <Button style={{ marginLeft : '10px' }} bsSize="sm" bsStyle="link" onClick={() => { this.setState( { showDialog : true } ) }}>Edit</Button>
          </LabelGroup>
          <LabelGroup>
            <label />
            <InsetSection style={{ width : '100%' }}>
              <div className={routes ? style.metadata : style.noMetadata}>{JSON.stringify( routes ) || 'No routes data' }</div> 
            </InsetSection>
          </LabelGroup>
        </LabelGroup>

        <LabelGroup>
          <label />
          <Text type="dim" className={style.identifier}>
            {`created ${moment( messageRoute.created ).format( 'lll' )}` }
          </Text>
        </LabelGroup>

        <JsonEditorDialog 
          title="Message Route - Routes Object"
          message="Enter the JSON object for the routes"
          show={this.state.showDialog} 
          onOk={( val ) => {
            // messageRoute.routes = val; 
            this.changePath( 'routes', val, false )
            this.setState( { showDialog : false } ) 
          }}
          onCancel={() => { this.setState( { showDialog : false } ) }}
          value={messageRoute.routes} />
          
      </Flex>
    ) 
  }
}
